<!-- 线性图 -->
<template>
  <div>
    <p>送达用户数 累计触发人次： {{sendNum}}</p>
    <p>点击用户数 累计触发人次： {{clickNum}}</p>
    <div id="map">暂无数据...</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  /* eslint-disable */
  props: ["mapData"],
  data () {
    return {
      option: {
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          bottom: 80
        },
        legend: {
          x: "center",
          y: 'top',
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: "送达用户数",
            data: [],
            type: "line"
          },
          {
            name: "点击用户数",
            data: [],
            type: "line"
          }
        ]
      },
      sendNum: 0,
      clickNum: 0
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {
    // console.log(this.LineMap);
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.flush();
  },
  methods: {
    refreshMap () {
      const myChart = echarts.init(document.getElementById("map"));
      myChart.setOption(this.option);
    },
    flush () {
      if (this.mapData) {
        let clicknum = [];
        let sendnum = [];
        let datadate = [];
        this.$http
          .get(
            `https://cdp.h5sites.com/scrm-platform/v1/Market/regular/mission/analysis?missionid=${this.mapData}`
          )
          .then(res => {
            if (res.data.flag) {
              this.sendNum = res.data.data.sendNum;
              this.clickNum = res.data.data.clickNum;
              res.data.data &&
                res.data.data.list.map(item => {
                  clicknum.push(item.clicknum);
                  datadate.push(item.datadate);
                  sendnum.push(item.sendnum);
                });
              this.option.xAxis.data = datadate;
              this.option.series[0].data = sendnum;
              this.option.series[1].data = clicknum;
              this.refreshMap();
            }
          });
      }
    }
  },
  watch: {
    mapData () {
      this.flush();
    }
  }
};
</script>
<style  scoped lang='less'>
/* @import url(); 引入css类 */
#map {
  width: 100%;
  min-height: 430px;
}
p {
  text-align: left;
  font-weight: bold;
}
</style>
